import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, InputType } from './formly-builder.models';
import { LuFormlyInputBuilder } from './input.builder';

export class LuFormlyNumberBuilder extends LuFormlyInputBuilder {
	protected type = FieldType.INPUT;
	inputType = InputType.NUMBER;
	private minValue: number = null;
	private maxValue: number = null;
	private step: number = null;

	public setMinValue(minValue: number): this {
		this.minValue = minValue;
		return this;
	}

	public setMaxValue(maxValue: number): this {
		this.maxValue = maxValue;
		return this;
	}

	public setStep(step: number): this {
		this.step = step;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();

		field.templateOptions.min = this.minValue;
		field.templateOptions.max = this.maxValue;
		field.templateOptions.step = this.step;

		return field;
	}
}
